(() => {
  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.mffSwipeReady) return;
    gallery.dataset.mffSwipeReady = 'true';
    const slider = gallery.querySelector('[data-mff-product-slider]');
    const slides = [...gallery.querySelectorAll('[data-mff-product-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-mff-thumb]')];
    if (!slider || !slides.length) return;
    const setActive = (index) => thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => {
      const target = document.getElementById(thumb.dataset.target);
      target?.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
      setActive(index);
    }));
    let raf = 0;
    slider.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const index = Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / Math.max(1, slider.clientWidth))));
        setActive(index);
      });
    }, {passive:true});
  };
  const boot = (root=document) => root.querySelectorAll('[data-mff-gallery]').forEach(initGallery);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => boot(), {once:true}) : boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
